<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName"
      ><i class="lt"></i><i class="rt"></i>
      <el-tab-pane name="xjrwgl">
        <span slot="label"
          ><i class="iconfont iconcheck"></i
          ><i class="border"></i> 健康评分标准管理
        </span>
        <normalNav :parent="self">
          <button class="GreenSmBtn download" @click="openAddDialog">
            新增
          </button>
        </normalNav>
        <div class="searchForm1">
          <searchForm
            :items="items"
            :formPlus="form_xjrwgl"
            ref="searchForm_xjrwgl"
          >
          </searchForm>
        </div>
        <div class="tableWrapper">
          <easyTable
            apiUrl="operation/healthCheckingStandard/list"
            :parent="self"
            :config="config"
            :other="other"
            ref="table_xjrwgl"
          >
            <template slot="last">
              <el-table-column label="操作" width="280" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="editRecord(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="deleteRecord(scope.row.id)"
                    >删除</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="viewDetails(scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="openThresholdConfig(scope.row)"
                    >阈值配置</el-button
                  >
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>

        <el-dialog
          class="editDialog"
          :title="isEdit ? '编辑健康评分标准' : '新增健康评分标准'"
          :visible.sync="editDialogVisible"
          :close-on-click-modal="false"
        >
          <section class="list">
            <el-form
              ref="form1"
              :model="form1"
              :rules="rules"
              label-position="right"
            >
              <el-form-item label="健康评估类型" prop="healthCheckingType">
                <el-select
                  v-model="form1.healthCheckingType"
                  placeholder="请选择健康评估类型"
                >
                  <el-option label="整体" :value="1"></el-option>
                  <el-option label="分区" :value="2"></el-option>
                  <el-option label="独立监测单元" :value="3"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="健康指标系统标识" prop="healthIndicatorCode">
                <el-input
                  class="darkSelect"
                  v-model="form1.healthIndicatorCode"
                  placeholder="请输入健康指标系统标识"
                ></el-input>
              </el-form-item>

              <el-form-item label="健康指标系统名称" prop="healthIndicatorName">
                <el-input
                  class="darkSelect"
                  v-model="form1.healthIndicatorName"
                  placeholder="请输入健康指标系统名称"
                ></el-input>
              </el-form-item>

              <el-form-item label="独立监测单元名称" prop="unitType">
                <el-input
                  class="darkSelect"
                  v-model="form1.unitType"
                  placeholder="请输入独立监测单元名称"
                ></el-input>
              </el-form-item>

              <el-form-item label="健康阈值" prop="healthThreshold">
                <el-input
                  class="darkSelect"
                  v-model="form1.healthThreshold"
                  placeholder="请输入健康阈值"
                ></el-input>
              </el-form-item>

              <el-form-item label="亚健康阈值" prop="subHealthThreshold">
                <el-input
                  class="darkSelect"
                  v-model="form1.subHealthThreshold"
                  placeholder="请输入亚健康阈值"
                ></el-input>
              </el-form-item>

              <el-form-item label="异常阈值" prop="abnormalThreshold">
                <el-input
                  class="darkSelect"
                  v-model="form1.abnormalThreshold"
                  placeholder="请输入异常阈值"
                ></el-input>
              </el-form-item>

              <el-form-item label="默认评分" prop="defaultScore">
                <el-input
                  class="darkSelect"
                  v-model="form1.defaultScore"
                  placeholder="请输入默认评分"
                ></el-input>
              </el-form-item>

              <el-form-item label="评估评分" prop="evaluationScore">
                <el-input
                  class="darkSelect"
                  v-model="form1.evaluationScore"
                  placeholder="请输入评估评分"
                ></el-input>
              </el-form-item>

              <el-form-item label="健康状况" prop="healthStatus">
                <el-input
                  class="darkSelect"
                  v-model="form1.healthStatus"
                  placeholder="请输入健康状况"
                ></el-input>
              </el-form-item>

              <el-form-item label="备注说明" prop="remark">
                <el-input
                  class="darkSelect"
                  type="textarea"
                  v-model="form1.remark"
                  placeholder="请输入备注说明"
                ></el-input>
              </el-form-item>
            </el-form>
          </section>

          <div slot="footer" class="dialog-footer">
            <el-button class="confirmButton" type="primary" @click="submitForm"
              >提交</el-button
            >
            <el-button class="cancelButton" type="primary" @click="closeDialog"
              >取消</el-button
            >
          </div>
        </el-dialog>

        <el-dialog
          class="editDialog"
          title="查看详情"
          :visible.sync="detailsVisible"
          :close-on-click-modal="false"
        >
          <section class="list">
            <el-form
              ref="detailsForm"
              :model="detailsList"
              label-position="right"
            >
              <el-form-item label="健康评估类型">
                <el-input
                  class="darkSelect"
                  :value="
                    displayHealthCheckingType(detailsList.healthCheckingType)
                  "
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="健康指标系统标识">
                <el-input
                  class="darkSelect"
                  v-model="detailsList.healthIndicatorCode"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="健康指标系统名称">
                <el-input
                  class="darkSelect"
                  v-model="detailsList.healthIndicatorName"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="独立监测单元名称">
                <el-input
                  class="darkSelect"
                  v-model="detailsList.unitType"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="健康阈值">
                <el-input
                  class="darkSelect"
                  v-model="detailsList.healthThreshold"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="亚健康阈值">
                <el-input
                  class="darkSelect"
                  v-model="detailsList.subHealthThreshold"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="异常阈值">
                <el-input
                  class="darkSelect"
                  v-model="detailsList.abnormalThreshold"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="默认评分">
                <el-input
                  class="darkSelect"
                  v-model="detailsList.defaultScore"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="评估评分">
                <el-input
                  class="darkSelect"
                  v-model="detailsList.evaluationScore"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="健康状况">
                <el-input
                  class="darkSelect"
                  v-model="detailsList.healthStatus"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="备注说明">
                <el-input
                  class="darkSelect"
                  type="textarea"
                  v-model="detailsList.remark"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-form>
          </section>
          <div slot="footer" class="dialog-footer">
            <el-button
              class="cancelButton"
              type="primary"
              @click="detailsVisible = false"
              >关闭</el-button
            >
          </div>
        </el-dialog>

        <!-- 阈值配置弹窗 -->
        <el-dialog
          class="editDialog"
          title="阈值配置"
          :visible.sync="thresholdDialogVisible"
          :close-on-click-modal="false"
          width="80%"
        >
          <div class="threshold-config-content">
            <div class="searchForm1">
              <searchForm
                :items="thresholdItems"
                :formPlus="thresholdForm"
                ref="searchForm_threshold"
              >
              </searchForm>
            </div>
            <div class="tableWrapper">
              <easyTable
                :apiUrl="thresholdApiUrl"
                :parent="self"
                :config="thresholdConfig"
                :other="thresholdOther"
                ref="table_threshold"
                @data-loaded="onThresholdDataLoaded"
              >
                <template slot="last">
                  <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="small"
                        @click="editThresholdRecord(scope.row)"
                        >编辑</el-button
                      >
                      <el-button
                        type="text"
                        size="small"
                        @click="deleteThresholdRecord(scope.row.id)"
                        >删除</el-button
                      >
                      <el-button
                        type="text"
                        size="small"
                        @click="viewThresholdDetails(scope.row)"
                        >查看</el-button
                      >
                    </template>
                  </el-table-column>
                </template>
              </easyTable>
            </div>

            <div class="threshold-actions">
              <button
                class="GreenSmBtn download"
                @click="openAddThresholdDialog"
              >
                新增阈值配置
              </button>
            </div>
          </div>
        </el-dialog>

        <!-- 阈值配置编辑/新增弹窗 -->
        <el-dialog
          class="editDialog"
          :title="isEditThreshold ? '编辑阈值配置' : '新增阈值配置'"
          :visible.sync="thresholdEditDialogVisible"
          :close-on-click-modal="false"
        >
          <section class="list">
            <el-form
              ref="thresholdFormRef"
              :model="thresholdForm1"
              :rules="thresholdRules"
              label-position="right"
            >
              <el-form-item label="设备类型" prop="deviceType">
                <el-input
                  class="darkSelect"
                  v-model="thresholdForm1.deviceType"
                  placeholder="请输入设备类型"
                ></el-input>
              </el-form-item>

              <el-form-item label="设备类型ID" prop="deviceTypeId">
                <el-input
                  class="darkSelect"
                  v-model="thresholdForm1.deviceTypeId"
                  placeholder="请输入设备类型ID"
                ></el-input>
              </el-form-item>

              <el-form-item label="可量化采集指标名称" prop="indicatorName">
                <el-input
                  class="darkSelect"
                  v-model="thresholdForm1.indicatorName"
                  placeholder="请输入可量化采集指标名称"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="可量化采集指标数据流标识"
                prop="indicatorDataFlag"
              >
                <el-input
                  class="darkSelect"
                  v-model="thresholdForm1.indicatorDataFlag"
                  placeholder="请输入可量化采集指标数据流标识"
                ></el-input>
              </el-form-item>

              <el-form-item label="可量化采集指标单位" prop="indicatorUnit">
                <el-input
                  class="darkSelect"
                  v-model="thresholdForm1.indicatorUnit"
                  placeholder="请输入可量化采集指标单位"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="可量化采集指标健康范围"
                prop="indicatorHealthRange"
              >
                <el-input
                  class="darkSelect"
                  v-model="thresholdForm1.indicatorHealthRange"
                  placeholder="请输入可量化采集指标健康范围"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="可量化采集指标亚健康范围"
                prop="indicatorSubHealthRange"
              >
                <el-input
                  class="darkSelect"
                  v-model="thresholdForm1.indicatorSubHealthRange"
                  placeholder="请输入可量化采集指标亚健康范围"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="可量化采集指标异常范围"
                prop="indicatorAbnormalRange"
              >
                <el-input
                  class="darkSelect"
                  v-model="thresholdForm1.indicatorAbnormalRange"
                  placeholder="请输入可量化采集指标异常范围"
                ></el-input>
              </el-form-item>

              <el-form-item label="指标默认值" prop="indicatorDefaultValue">
                <el-input
                  class="darkSelect"
                  v-model="thresholdForm1.indicatorDefaultValue"
                  placeholder="请输入指标默认值"
                ></el-input>
              </el-form-item>

              <el-form-item label="评分权重" prop="scoreWeight">
                <el-input
                  class="darkSelect"
                  v-model="thresholdForm1.scoreWeight"
                  placeholder="请输入评分权重"
                ></el-input>
              </el-form-item>
            </el-form>
          </section>

          <div slot="footer" class="dialog-footer">
            <el-button
              class="confirmButton"
              type="primary"
              @click="submitThresholdForm"
              >提交</el-button
            >
            <el-button
              class="cancelButton"
              type="primary"
              @click="closeThresholdDialog"
              >取消</el-button
            >
          </div>
        </el-dialog>

        <!-- 阈值配置详情弹窗 -->
        <el-dialog
          class="editDialog"
          title="查看阈值配置详情"
          :visible.sync="thresholdDetailsVisible"
          :close-on-click-modal="false"
        >
          <section class="list">
            <el-form
              ref="thresholdDetailsForm"
              :model="thresholdDetailsList"
              label-position="right"
            >
              <el-form-item label="设备类型">
                <el-input
                  class="darkSelect"
                  v-model="thresholdDetailsList.deviceType"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="设备类型ID">
                <el-input
                  class="darkSelect"
                  v-model="thresholdDetailsList.deviceTypeId"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="可量化采集指标名称">
                <el-input
                  class="darkSelect"
                  v-model="thresholdDetailsList.indicatorName"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="可量化采集指标数据流标识">
                <el-input
                  class="darkSelect"
                  v-model="thresholdDetailsList.indicatorDataFlag"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="可量化采集指标单位">
                <el-input
                  class="darkSelect"
                  v-model="thresholdDetailsList.indicatorUnit"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="可量化采集指标健康范围">
                <el-input
                  class="darkSelect"
                  v-model="thresholdDetailsList.indicatorHealthRange"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="可量化采集指标亚健康范围">
                <el-input
                  class="darkSelect"
                  v-model="thresholdDetailsList.indicatorSubHealthRange"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="可量化采集指标异常范围">
                <el-input
                  class="darkSelect"
                  v-model="thresholdDetailsList.indicatorAbnormalRange"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="指标默认值">
                <el-input
                  class="darkSelect"
                  v-model="thresholdDetailsList.indicatorDefaultValue"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="评分权重">
                <el-input
                  class="darkSelect"
                  v-model="thresholdDetailsList.scoreWeight"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-form>
          </section>
          <div slot="footer" class="dialog-footer">
            <el-button
              class="cancelButton"
              type="primary"
              @click="thresholdDetailsVisible = false"
              >关闭</el-button
            >
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { obj2urlsp, descriptor } from "utils";
export default {
  data() {
    return {
      tabName: "xjrwgl",
      form_xjrwgl: {},
      editLoading: true,
      editDialogVisible: false,
      detailsVisible: false,
      detailsList: {},
      data: {},
      other: {},
      form1: {},
      isEdit: false,
      rules: {
        healthCheckingType: [
          { required: true, message: "请选择健康评估类型", trigger: "change" }
        ],
        healthIndicatorCode: [
          { required: true, message: "请输入健康指标系统标识", trigger: "blur" }
        ],
        healthIndicatorName: [
          { required: true, message: "请输入健康指标系统名称", trigger: "blur" }
        ],
        healthThreshold: [
          { required: true, message: "请输入健康阈值", trigger: "blur" }
        ],
        subHealthThreshold: [
          { required: true, message: "请输入亚健康阈值", trigger: "blur" }
        ],
        abnormalThreshold: [
          { required: true, message: "请输入异常阈值", trigger: "blur" }
        ],
        defaultScore: [
          { required: false, message: "请输入默认评分", trigger: "blur" }
        ]
      },
      // 阈值配置相关状态
      thresholdDialogVisible: false,
      thresholdStandardId: null,
      thresholdForm: {},
      thresholdOther: {},
      thresholdApiUrl: "",
      thresholdData: {},
      thresholdEditDialogVisible: false,
      thresholdDetailsVisible: false,
      thresholdDetailsList: {},
      thresholdForm1: {},
      isEditThreshold: false,
      thresholdRules: {
        deviceType: [
          { required: true, message: "请输入设备类型", trigger: "blur" }
        ],
        indicatorName: [
          {
            required: true,
            message: "请输入可量化采集指标名称",
            trigger: "blur"
          }
        ],
        indicatorDataFlag: [
          {
            required: true,
            message: "请输入可量化采集指标数据流标识",
            trigger: "blur"
          }
        ],
        scoreWeight: [
          { required: true, message: "请输入评分权重", trigger: "blur" }
        ]
      }
    };
  },
  watch: {
    editDialogVisible(val) {
      if (!val) {
        this.resetForm();
      }
    },
    // 当阈值配置弹窗关闭时重置表单
    thresholdEditDialogVisible(val) {
      if (!val) {
        this.resetThresholdForm();
      }
    }
  },
  computed: {
    items() {
      return [
        {
          type: "input",
          prop: "healthIndicatorCode",
          label: "健康指标系统标识",
          placeholder: "请输入健康指标系统标识"
        },
        {
          type: "input",
          prop: "healthIndicatorName",
          label: "健康指标系统名称",
          placeholder: "请输入健康指标系统名称"
        },
        {
          type: "select",
          prop: "healthCheckingType",
          label: "健康评估类型",
          placeholder: "请选择健康评估类型",
          option: {
            option: [
              { label: "整体", value: 1 },
              { label: "分区", value: 2 },
              { label: "独立监测单元", value: 3 }
            ]
          }
        }
      ];
    },
    // 阈值配置搜索项
    thresholdItems() {
      return [
        {
          type: "input",
          prop: "indicatorName",
          label: "采集指标",
          placeholder: "请输入可量化采集指标名称"
        },
        {
          type: "input",
          prop: "deviceType",
          label: "设备类型",
          placeholder: "请输入设备类型"
        }
      ];
    },
    self() {
      return this;
    },
    config() {
      return [
        {
          label: "健康评估类型",
          prop: row => {
            return this.displayHealthCheckingType(row.healthCheckingType);
          }
        },
        {
          prop: "healthIndicatorCode",
          label: "健康指标系统标识"
        },
        {
          prop: "healthIndicatorName",
          label: "健康指标系统名称"
        },
        {
          prop: "unitType",
          label: "独立监测单元名称"
        },
        {
          prop: "healthThreshold",
          label: "健康阈值"
        },
        {
          prop: "subHealthThreshold",
          label: "亚健康阈值"
        },
        {
          prop: "abnormalThreshold",
          label: "异常阈值"
        },
        {
          prop: "defaultScore",
          label: "默认评分"
        },
        {
          prop: "evaluationScore",
          label: "评估评分"
        },
        {
          prop: "healthStatus",
          label: "健康状况"
        },
        {
          prop: "remark",
          label: "备注"
        }
      ];
    },
    // 阈值配置表格列配置
    thresholdConfig() {
      return [
        {
          prop: "deviceType",
          label: "设备类型"
        },
        {
          prop: "deviceTypeId",
          label: "设备类型ID"
        },
        {
          prop: "indicatorName",
          label: "可量化采集指标名称"
        },
        {
          prop: "indicatorDataFlag",
          label: "可量化采集指标数据流标识"
        },
        {
          prop: "indicatorUnit",
          label: "可量化采集指标单位"
        },
        {
          prop: "indicatorHealthRange",
          label: "可量化采集指标健康范围"
        },
        {
          prop: "indicatorSubHealthRange",
          label: "可量化采集指标亚健康范围"
        },
        {
          prop: "indicatorAbnormalRange",
          label: "可量化采集指标异常范围"
        },
        {
          prop: "indicatorDefaultValue",
          label: "指标默认值"
        },
        {
          prop: "scoreWeight",
          label: "评分权重"
        }
      ];
    }
  },
  methods: {
    reset_xjrwgl(fn) {
      fn();
      this.form_xjrwgl = {};
    },
    search_xjrwgl(fn) {
      fn();
    },
    openAddDialog() {
      this.isEdit = false;
      this.editDialogVisible = true;
      this.form1 = {
        healthCheckingType: null,
        healthIndicatorCode: "",
        healthIndicatorName: "",
        unitType: "",
        healthThreshold: "",
        subHealthThreshold: "",
        abnormalThreshold: "",
        defaultScore: "",
        evaluationScore: "",
        healthStatus: "",
        remark: ""
      };
    },
    editRecord(row) {
      this.isEdit = true;
      this.editDialogVisible = true;
      this.form1 = { ...row };
    },
    viewDetails(row) {
      this.detailsList = { ...row };
      this.detailsVisible = true;
    },
    submitForm() {
      this.$refs["form1"].validate(valid => {
        if (valid) {
          if (this.isEdit) {
            // 更新操作
            this.updateRecord(this.form1);
          } else {
            // 添加操作
            this.addRecord(this.form1);
          }
        }
      });
    },
    addRecord(data) {
      this.$axiospost("operation/healthCheckingStandard/add", data)
        .then(res => {
          if (res.data.status === "10000" || res.data.status === 10000) {
            this.$message.success("添加成功！");
            this.closeDialog();
            this.$refs["table_xjrwgl"].getData();
          } else {
            this.$message.error(
              "添加失败：" + (res.data.message || res.data.msg)
            );
          }
        })
        .catch(err => {
          console.error("添加健康评分标准错误:", err);
          this.$message.error("添加失败，请检查网络或联系管理员");
        });
    },
    updateRecord(data) {
      this.$axiospost("operation/healthCheckingStandard/update", data)
        .then(res => {
          if (res.data.status === "10000" || res.data.status === 10000) {
            this.$message.success("更新成功！");
            this.closeDialog();
            this.$refs["table_xjrwgl"].getData();
          } else {
            this.$message.error(
              "更新失败：" + (res.data.message || res.data.msg)
            );
          }
        })
        .catch(err => {
          console.error("更新健康评分标准错误:", err);
          this.$message.error("更新失败，请检查网络或联系管理员");
        });
    },
    deleteRecord(id) {
      this.$confirm("确认删除这条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axiosdelete(`operation/healthCheckingStandard/delete?id=${id}`)
            .then(res => {
              if (res.data.status === "10000" || res.data.status === 10000) {
                this.$message.success("删除成功！");
                this.$refs["table_xjrwgl"].getData();
              } else {
                this.$message.error(
                  "删除失败：" + (res.data.message || res.data.msg)
                );
              }
            })
            .catch(err => {
              console.error("删除健康评分标准错误:", err);
              this.$message.error("删除失败，请检查网络或联系管理员");
            });
        })
        .catch(() => {
          // 用户取消删除
        });
    },
    closeDialog() {
      this.editDialogVisible = false;
      this.resetForm();
    },
    resetForm() {
      if (this.$refs["form1"]) {
        this.$refs["form1"].resetFields();
      }
      this.form1 = {};
    },
    displayHealthCheckingType(type) {
      switch (type) {
        case 1:
          return "整体";
        case 2:
          return "分区";
        case 3:
          return "独立监测单元";
        default:
          return "未知";
      }
    },
    // 打开阈值配置弹窗
    openThresholdConfig(row) {
      this.thresholdStandardId = row.id;
      this.thresholdApiUrl = `operation/healthCheckingTrigger/findByStandardId?standardId=${row.id}`;
      this.thresholdDialogVisible = true;
    },
    // 阈值配置表格数据加载完成后执行
    onThresholdDataLoaded(response) {
      // 如果API返回的数据结构不同，可能需要调整
      if (response && response.data && Array.isArray(response.data)) {
        this.thresholdData = response.data;
      } else if (
        response &&
        response.data &&
        Array.isArray(response.data.rows)
      ) {
        this.thresholdData = response.data.rows;
      }
    },
    // 打开新增阈值配置弹窗
    openAddThresholdDialog() {
      this.isEditThreshold = false;
      this.thresholdEditDialogVisible = true;
      this.thresholdForm1 = {
        id: 0,
        standardId: this.thresholdStandardId,
        deviceType: "",
        deviceTypeId: "",
        indicatorName: "",
        indicatorDataFlag: "",
        indicatorUnit: "",
        indicatorHealthRange: "",
        indicatorSubHealthRange: "",
        indicatorAbnormalRange: "",
        indicatorDefaultValue: "",
        scoreWeight: ""
      };
    },
    // 编辑阈值配置
    editThresholdRecord(row) {
      this.isEditThreshold = true;
      this.thresholdEditDialogVisible = true;
      this.thresholdForm1 = { ...row };
    },
    // 查看阈值配置详情
    viewThresholdDetails(row) {
      this.thresholdDetailsList = { ...row };
      this.thresholdDetailsVisible = true;
    },
    // 提交阈值配置表单
    submitThresholdForm() {
      this.$refs["thresholdFormRef"].validate(valid => {
        if (valid) {
          if (this.isEditThreshold) {
            // 更新操作
            this.updateThresholdRecord(this.thresholdForm1);
          } else {
            // 添加操作
            this.addThresholdRecord(this.thresholdForm1);
          }
        }
      });
    },
    // 添加阈值配置
    addThresholdRecord(data) {
      // 确保标准ID已设置
      data.standardId = this.thresholdStandardId;

      this.$axiospost("operation/healthCheckingTrigger/add", data)
        .then(res => {
          if (res.data.status === "10000" || res.data.status === 10000) {
            this.$message.success("添加阈值配置成功！");
            this.closeThresholdDialog();
            this.$refs["table_threshold"].getData();
          } else {
            this.$message.error(
              "添加阈值配置失败：" + (res.data.message || res.data.msg)
            );
          }
        })
        .catch(err => {
          console.error("添加阈值配置错误:", err);
          this.$message.error("添加阈值配置失败，请检查网络或联系管理员");
        });
    },
    // 更新阈值配置
    updateThresholdRecord(data) {
      this.$axiospost("operation/healthCheckingTrigger/update", data)
        .then(res => {
          if (res.data.status === "10000" || res.data.status === 10000) {
            this.$message.success("更新阈值配置成功！");
            this.closeThresholdDialog();
            this.$refs["table_threshold"].getData();
          } else {
            this.$message.error(
              "更新阈值配置失败：" + (res.data.message || res.data.msg)
            );
          }
        })
        .catch(err => {
          console.error("更新阈值配置错误:", err);
          this.$message.error("更新阈值配置失败，请检查网络或联系管理员");
        });
    },
    // 删除阈值配置
    deleteThresholdRecord(id) {
      this.$confirm("确认删除这条阈值配置记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axiosdelete(`operation/healthCheckingTrigger/delete?id=${id}`)
            .then(res => {
              if (res.data.status === "10000" || res.data.status === 10000) {
                this.$message.success("删除阈值配置成功！");
                this.$refs["table_threshold"].getData();
              } else {
                this.$message.error(
                  "删除阈值配置失败：" + (res.data.message || res.data.msg)
                );
              }
            })
            .catch(err => {
              console.error("删除阈值配置错误:", err);
              this.$message.error("删除阈值配置失败，请检查网络或联系管理员");
            });
        })
        .catch(() => {
          // 用户取消删除
        });
    },
    // 关闭阈值配置编辑弹窗
    closeThresholdDialog() {
      this.thresholdEditDialogVisible = false;
      this.resetThresholdForm();
    },
    // 重置阈值配置表单
    resetThresholdForm() {
      if (this.$refs["thresholdFormRef"]) {
        this.$refs["thresholdFormRef"].resetFields();
      }
      this.thresholdForm1 = {};
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    nextCompany: () => import("public/nextCompany")
  },
  mounted() {
    // 组件挂载时可能需要初始化数据，目前保持原有逻辑
  }
};
</script>

<style lang="less" scoped>
.point {
  span {
    padding-left: 5px;
    color: #fff;
    font-size: 14px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-left: 2px solid #35b9f7;
  }

  border-bottom: 1px solid #777;
  line-height: 36px;
  margin-top: 15px;
  margin-bottom: 15px;
}
/deep/ .editDialog .el-form-item__label {
  text-align: right !important;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  margin-left: 10px;
  font-size: 10px;
}
.el-form-item__content {
  img {
    max-width: 400px;
    max-height: 400px;
  }
}

.threshold-config-content {
  .threshold-actions {
    margin-top: 20px;
    text-align: center;
    button{
        width: 100px;
    }
  }
}
// 修复searchForm标签文字拥挤问题
.threshold-config-content /deep/ .el-form-item__label {
  white-space: nowrap;
}
.threshold-config-content /deep/ .el-form-item {
  width: 30%;
}
</style>


// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/standardEvaluation/scoringConfiguration/index.vue